import {IHttpService, ILogService, IPromise, IQService} from "angular";
import {User} from "../model/User";
import {LoginDetails} from "../model/LoginDetails";

const transformToUser = (responseData: any): User => {
    if (responseData == null) {
        return null;
    }

    return new User(
        responseData.username,
        responseData.email,
        responseData.phoneNumber,
        responseData.givenName,
        responseData.surName,
        responseData.preferredName,
        responseData.callistaPersonId,
        responseData.sapEmployeeNumber,
        responseData.isStudent,
        responseData.isStaff,
        responseData.isProspectiveStudent,
        responseData.isAssessor,
        responseData.faculties,
        responseData.isCentralAdmissions,
        responseData.applicantId,
        responseData.isMonashOnlineEducation
    );
};

export class AuthService {
    private loggedInUser: User;

    /* @ngInject */
    constructor(private $http: IHttpService,
                private $log: ILogService,
                private $q: IQService) {
    }

    public isAuthenticated(): IPromise<boolean> {
        return this.me()
            .then(() => true)
            .catch(() => false);
    }

    public loginProspectiveStudent(loginDetails: LoginDetails): IPromise<User> {
        return this.$http.post("/api/login/student", loginDetails)
            .then(this.handleUserResponse);
    }

    public logout(): IPromise<void> {
        return this.$http.post("/api/logout", {})
            .then(() => {
                this.loggedInUser = null;
            });
    }

    public me(): IPromise<User> {
        if (this.loggedInUser) {
            return this.$q.resolve(this.loggedInUser);
        }

        return this.$http.get("/api/user/me")
            .then(this.handleUserResponse);
    }

    private handleUserResponse = (response): User => {
        this.$log.debug("current user response:", response);
        this.loggedInUser = transformToUser(response.data);
        return this.loggedInUser;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/auth/auth.service.ts